
export default {
  tip: '提示',
  toDealWith: '前往處理',
  dealWithtips: '請記得在-結算中-上傳相關的文件 (公司蓋章和簽名)',
  loading: '加載數據中...',
  loginTimeout: '登錄超時',
  errorMsg: '錯誤信息',
  systemError: '系統錯誤',
  pageIsLost: '抱歉，頁面找不到了',
  reLogin: '重新登錄',
  save: '保存',
  cancel: '取消',
  search: '搜索',
  reset: '重置',
  confirm: '確定',
  opera: '操作 {tips}',
  downloadFile: '文件下載',
  yes: '是',
  no: '否',
  underSubmission: '提交中 ...',
  prevText: '上一頁',
  nextText: '下一頁',
  keyWord: '關鍵字',
  all: '全部',
  jan: '1月',
  feb: '2月',
  mar: '3月',
  apr: '4月',
  may: '5月',
  jun: '6月',
  jul: '7月',
  aug: '8月',
  sep: '9月',
  oct: '10月',
  nov: '11月',
  dec: '12月',
  to: '至',
  add: '新增',
  state: '狀態',
  showImg: '圖片展示',
  close: '關閉',
  followRemark: '跟進備註',
  plsSelect: '請選擇',
  submit:'提交',
  remark:'註',
  cancelled:'已取消',
  importantHint:'重要提示',
  alreadyExists:'已經存在',
  type: '類別',
  name: '名稱',
  size: '大小',
  download: '下載',
  reUpload: '重新上傳',
  delete: '刪除',
  append: '添加',
  remove: '移除',
  edit: '編輯',
  national: '國籍/地區',
  gender: '性別',
  birthday: '出生日期',
  birthPlace: '出生地址',
  motherTongue: '母語',
  race: '種族',
  tuitionFee: '學費支付',
  idCard: '身份證',
  passport: '護照',
  issueDate: '簽發日期',
  expireDate: '到期日期',
  issueState: '簽發國家/地區',
  grade: '年級',
  curriculum: 'Curriculum',
  homeTel: '住宅電話',
  mobile: '手機',
  email: '電郵',
  homePlace: '住宅地址',
  dontHave: '沒有',
  lastWeek: '最近一週',
  lastMonth: '最近一個月',
  lastThreeMonths: '最近三個月',
  serialNumber: '序號',
  check: '查看',
  active: '激活',
  gmtCreateUser: '創建人',
  gmtCreate: '創建時間',
  refresh: '刷新',
  wechat: '微信',
  cancelAndClose: '取消並關閉',
  role: '角色',
  searchPlaceholder: '請輸入搜索內容',
  viewMore: '查看更多',
  noPermission: '當前賬號沒有權限',
  remarkMessage: '留言備註',
  company: '公司',
  personalAccountCompany: '個人賬戶公司',
  person: '個人',
  studio: '工作室',
  internationalSchool: '國際學校',
  other: '其他',
  return: '返回',
  submitSuccess: '提交成功',
  submitFail: '提交失敗',
  telephone: '電話',
  onlineForm: '線上表單',
  downloadForm: '下載表單',
  resourceManagementItemName1: '澳洲及新西蘭',
  resourceManagementTitle: '院校申請指引及申請費',
  noData: "暫無數據",
  studentsCount: '共{total}名學生',
  applicationCount: '{totalApply}個申請',
  fileUploadTips: '不支持該文件的格式，請重新上傳符合格式要求的文件！',
  fileUploadTips2: '文件大小不超過{size}M，請您重新上傳符合要求的文件！',
  quickAccess: '快捷入口',
  preview: '預覽',
  continue: '繼續',
  focusCityTips: '請先選擇國家或者省份',
  focusProvinceTips: '請先選擇國家',
  dataTotalNumber: '共{totalNumber}條數據',
  gearUpdateReminder:'GEAR更新提醒',
  errorCode: '錯誤碼',
};
